export default {
  lang: {
    reset: 'Reset',
    search: 'Filtro',
    expand: 'Espandere',
    collapse: 'Stow',
  },
};
